<div class="fui-layout-container">
  <fui-layout-header [breadcrumbs]="breadcrumbs" headingText="fui-header.my_gear" [description]="'newdash.fender_gear_description'">
    @if (sharedProductsListCmp.allProducts.length) {
      <div class="fui-nav-pills m-t-30">
        <ul>
          <li>
            <button
              [class.active]="selectedProductCategory?.string_id == 'all'"
              (click)="appService.mobileMenuShown = false; selectProductCategory('all')"
              (keyup.enter)="appService.mobileMenuShown = false; selectProductCategory('all')"
              (keyup.space)="appService.mobileMenuShown = false; selectProductCategory('all')"
            >
              {{ "newdash.all" | translate }}
            </button>
          </li>
          @for (category of productService.productCategories; track category) {
            <li>
              @if (category.count) {
                <button
                  [class.active]="selectedProductCategory?.string_id == category.string_id"
                  (click)="appService.mobileMenuShown = false; selectProductCategory(category)"
                  (keyup.enter)="appService.mobileMenuShown = false; selectProductCategory(category)"
                  (keyup.space)="appService.mobileMenuShown = false; selectProductCategory(category)"
                >
                  {{ category.languages[helperService.selectedLanguage.code] }}
                </button>
              }
            </li>
          }
        </ul>
      </div>
    }
  </fui-layout-header>
  @if (!loading && sharedProductsListCmp.allProducts.length) {
    <hr />
  }
  <div class="fui-layout-edge-content">
    <myp-shared-products-list
      class="h-full"
      #sharedProductsListCmp
      (registerClicked)="registerProduct()"
      (listLoaded)="listLoaded($event)"
      [selectedCategory]="selectedProductCategory"
      (categorySelected)="selectProductCategory($event)"
    ></myp-shared-products-list>
  </div>
  <div class="m-t-100 p-b-50">
    <fui-footer></fui-footer>
  </div>
</div>
